// 判断是否是 手机 | ipad | pc
// 判断设备环境
export const deviceType = function () {
    const ua = navigator.userAgent;

    const isOpenHarmony = /OpenHarmony/i.test(ua);

    let isMobile;

    if (isOpenHarmony) {
        // OpenHarmony 特殊处理：
        // UA 中包含 PC → PC
        // 否则 → 移动设备
        isMobile = !/\bPC\b/i.test(ua);
    } else {
        isMobile =
            /Android|iPhone|iPod|iPad|Windows Phone|IEMobile|Opera Mini|BlackBerry|SymbianOS/i.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }

    return {
        isWechat: /MicroMessenger/i.test(ua),
        isPc: !isMobile,
    };
};

import { Message } from "element-ui";
import { Toast } from "vant";
import store from "@/store";

export function useMessage({ type, message }) {
    if (store.state.showMobileComponent) {
        if (type === "error") Toast.fail(message);
        else Toast.success(message);
    } else Message({ type, message });
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string") {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time);
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), "/");
            }
        }

        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
    });
    return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (("" + time).length === 10) {
        time = parseInt(time) * 1000;
    } else {
        time = +time;
    }
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return "刚刚";
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
        return "1天前";
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return d.getMonth() + 1 + "月" + d.getDate() + "日" + d.getHours() + "时" + d.getMinutes() + "分";
    }
}

/**
 * @description 获取指定cookie的值
 * @param {String} cname 要获取的cookie的key
 * @return {String} 如果获取到了，就返回该cookie的value，否则返回空字符串
 */
export function getCookie(cname) {
    var name = cname + "=";
    var ca = decodeURIComponent(document.cookie).split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return "";
}

/**
 * @description: 生成指定长度的随机字符串
 * @param {Number} length 长度
 * @return {String} 生成的指定长度的随机字符串
 */
export function generateRandomString(length = 16) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

/**
 * @description: 验证密码是否是数字+字母至少8位的组合
 * @param {String} password 密码
 * @return {Boolean} 验证通过返回 true,否则返回 false
 */
export function validatePassword(password) {
    var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    return regex.test(password);
}

/**
 * @description: 将手机号中间4位替换为星号
 * @param {String} phoneNumber 手机号
 * @return {String} 加密后的手机号
 */
export function hidePhoneNumber(phoneNumber = "***********") {
    return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}
